<template>
  <div class="Product-whitelist">
    <!-- 表单搜索 start -->
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="formData"
      @Refresh="onHandleRefresh"
      @search="onSearch"
    >
      <template v-slot:left>
        <el-button type="primary" @click="add">新增</el-button>
        <el-button type="primary" @click="del()">移除</el-button>
        <el-button type="text">移除的商品将恢复下架条件控制</el-button>
      </template>
    </Filtersearch>
    <!-- 表单搜索 end -->
    <!-- 列表 start -->
    <div class="table-wrap">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="center" width="100">
        </el-table-column>
        <el-table-column prop="sku_code" align="center" label="商品编码">
        </el-table-column>
        <el-table-column prop="title" align="center" label="商品名称">
          <template slot-scope="scope">
            <el-button type="text">{{ scope.row.title }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="grade" align="center" label="等级">
        </el-table-column>
        <el-table-column prop="spec" align="center" label="规格">
        </el-table-column>
        <el-table-column prop="price" align="center" label="开市价">
          <template slot="header" slot-scope="scope">
            <div class="title-item" @click="sortChange(1)">
              <div>开市价</div>
              <div class="title-item-icon">
                <i
                  :class="
                    formData.sort_key == 'price' && formData.sort == 'asc'
                      ? 'el-icon-caret-top active'
                      : 'el-icon-caret-top '
                  "
                ></i>
                <i
                  :class="
                    formData.sort_key == 'price' && formData.sort == 'desc'
                      ? 'el-icon-caret-bottom active'
                      : 'el-icon-caret-bottom'
                  "
                ></i>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="weight_price" align="center" label="净单价">
        </el-table-column>
        <el-table-column
          prop="quality_percent"
          align="center"
          label="7天售后率"
        >
        </el-table-column>
        <el-table-column prop="apply_percent" align="center" label="3天发起率">
        </el-table-column>
        <el-table-column prop="source_txt" align="center" label="来源">
        </el-table-column>
        <el-table-column prop="origin_name" align="center" label="产地">
        </el-table-column>
        <el-table-column prop="create_time" align="center" label="添加时间">
        </el-table-column>
      </el-table>
    </div>
    <!-- 列表 end -->

    <!-- 分页 start -->
    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import Filtersearch from "@/components/Filtersearch.vue";

export default {
  name: "Product-whitelist",
  components: {
    Filtersearch,
  },
  data() {
    return {
      Filtersearchlist: [
        {
          type: "input",
          name: "商品名称",
          clearable: true,
          model: "title",
          placeholder: "请输入商品名称",
        },

        {
          type: "input",
          name: "商品编码",
          clearable: true,
          model: "sku_code",
          placeholder: "请输入商品编码",
        },
      ],

      loading: false,
      disabledExport: false, // 导出禁用
      formData: {
        logistic_business_id:'',
        page: 1, //	number	页码
        pageSize: 100, //	number	页大小
        sort: "",
        sort_key: "",
        title: "",
        sku_code: "",
      }, // 表单参数
      tableData: [], // 城市仓列表
      total: 0,
      multipleSelection: [],
    };
  },
  computed: {},
  mounted() {},
  created() {
    this.formData.logistic_business_id=sessionStorage.getItem("logistic_business_id", this.logistic_business_id);
    this.onInitData();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    add() {
      this.$router.push({
        path: `/Selectproduct?logistic_business_id=${sessionStorage.getItem("logistic_business_id", this.logistic_business_id)}`,
      });
    },
    del() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请选择至少一个品类",
          type: "error",
        });
        return;
      }

      this.$confirm("确定要移除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$api.examine
            .downwhiteremove({
              sku_code: this.multipleSelection.map((el) => el.sku_code),
            })
            .then((res) => {
              console.log(res, "停用或者开启");
              this.$message({
                type: "success",
                message: "移除成功",
              });
              this.hqlist();
            });
        })
        .catch(() => {});
    },
    sortChange(e) {
      if (e == 1) {
        this.formData.sort_key = "price";
      } else if (e == 2) {
        this.formData.sort_key = "weight";
      } else {
        this.formData.sort_key = "gross_weight";
      }
      this.formData.sort = this.formData.sort == "asc" ? "desc" : "asc";
      this.hqlist();
    },
    // 初始化
    onInitData() {
      this.hqlist();
    },
    // 获取列表
    async hqlist() {
      this.loading = true;

      this.$api.examine.downwhitelist(this.formData).then((res) => {
        this.loading = false;
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },

    /**
     * 重置表单，并刷新
     */
    onHandleRefresh() {
      Object.assign(this.$data.formData, this.$options.data().formData);
      this.formData.logistic_business_id=this.$route.query.logistic_business_id;
      this.hqlist();
    },
    /**
     * 搜索表单
     */
    onSearch(e) {
      this.formData.page = 1;
      this.formData = e;
      this.hqlist();
    },
    /**
     * 每页条数发生改变
     */
    onHandleSizeChange(val) {
      this.formData.pageSize = val;
      this.hqlist();
    },
    /**
     * 页码发生改变
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.hqlist();
    },
  },
};
</script>
<style lang="scss" scoped>
.Product-whitelist {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;

  .table-wrap {
    flex: 1;
    overflow-y: hidden;
  }
  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }
  .active {
    color: #42be85;
  }
  .title-item {
    display: flex;
    align-items: center;
    justify-content: center;
    .title-item-icon {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
